export const VIEW_HEIGHT = 1080
export const VIEW_WIDTH = 1920

export const WIDTH_COMPONENTS = {
    SIDE_BAR: '72px'
}

export const HEIGHT_COMPONENTS = {
    HEADER: '48px',
    SIDE_BAR: `calc(100vh - 48px`,
    BREADCRUM: '60px',
    BREADCRUM_MOBILE: '48px',
    SEARCH_BAR: '60px',
    FOOTER: '48px'
}

export const WIDTH_CONTENT_DIALOG = {
    MEDIUM: 500
}

export const PADDING_CONTENT_PAGE = { xs: '0 16px', md: '0 20px' }
export const PADDING_TABLE_WRAPPER = { xs: '16px 16px', md: '24px 20px' }

export const POSITION_DRAW = {
    LEFT: 'left'
}
